import {
	type FrontendPlacementMessage,
	type AnyFrontendStage,
} from '@post-office/message-maker-browser/types';
import { type NextBestAction } from '@post-office/confluence-next-best-action';
import type { BackendPlacementMessage } from '@post-office/message-maker-node/placements/types';
import type {
	AnyPayload,
	CreatePlacementMessageConfig,
} from '@post-office/message-template-contracts/placement-v2';
import {
	type AnyBackendMessageStage,
	type BackendSyncMessageStage,
} from '@post-office/message-maker-node/placements/types';
import {
	PlacementBackend,
	PlacementFrontend,
} from '@post-office/placements--growth/confluence-side-nav';
import {
	ConfluenceCloudCcpId,
	type TransformMetadataResult,
} from '@post-office/shared-contracts/message-template-metadata';

import { assertMessageTemplateContext } from '../../../__generated__/validation/messageTemplateContext';
import type { MessageTemplateContext } from '../../../index';

import { ConfluenceAgentsMcpNudgeBanner } from './components/confluence-agents-mcp-nudge-banner';

export const MessageBackend: (config: CreatePlacementMessageConfig) => BackendPlacementMessage<{
	transformMetadata: BackendSyncMessageStage<AnyPayload, TransformMetadataResult>;
	hydrate?: AnyBackendMessageStage;
}> = PlacementBackend.createMessageBackend(() => ({
	transformMetadata: {
		validate: assertMessageTemplateContext,
		stage: () => ({
			rerankingMetadata: { productId: ConfluenceCloudCcpId },
		}),
	},
}));

type MessageFrontendProps = MessageTemplateContext & {
	handleOnDismissed: () => void;
	onSideNavClick: (nextBestActionType: NextBestAction) => void;
};

export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: AnyFrontendStage;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: assertMessageTemplateContext,
		Component: ({ handleOnDismissed, onSideNavClick }: MessageFrontendProps) => (
			<ConfluenceAgentsMcpNudgeBanner onDismiss={handleOnDismissed} onSetup={onSideNavClick} />
		),
	},
});
